import { LucideIcon } from 'lucide-react';
import { FC, ReactNode } from 'react';

import Paragraph from '@/components/text/Paragraph.tsx';

interface Props {
    icon: LucideIcon;
    text: string | ReactNode;
}

const IconWithText: FC<Props> = ({ icon: Icon, text }) => {
    return (
        <div className="flex gap-2">
            {/* Mt is here in order to lower a bit icon to make it aligned with first line of text */}
            <Icon className="mt-0.5 size-4 flex-shrink-0 text-slate-700" />
            <Paragraph className="text-sm text-slate-700">{text}</Paragraph>
        </div>
    );
};

export default IconWithText;
